import { CheckCircle, Error } from '@mui/icons-material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Box, Button, LinearProgress, Typography } from '@mui/material';
import Flex from 'src/Components/Bases/Flex';
import { Status } from 'src/Enum/Report';

interface ProgressBarLayoutProps {
  status: Status;
  title: string;
  progress: number;
  path?: string;
  id?: number;
  isPublished: boolean;
}

const ProgressBarLayout: React.FC<ProgressBarLayoutProps> = ({
  status,
  title,
  progress,
  path,
  id,
  isPublished,
}) => {
  const handleEdit = (id?: number, path?: string) => {
    if (id) {
      window.location.href = `/report/${id}/${path}`;
    }
  };
  return (
    <Flex flexDirection="row" p={1}>
      <Flex p={1}>
        {status === Status.IN_PROGRESS && (
          <AccessTimeFilledIcon
            sx={(theme) => ({
              color: theme.palette.secondary.lighter,
            })}
          />
        )}
        {status === Status.PASS && (
          <CheckCircle
            sx={(theme) => ({ color: theme.palette.success.main })}
          />
        )}
        {status === Status.NOT_PASS && <Error />}
      </Flex>

      <Box width={1}>
        <Flex flexDirection="row" justifyContent="space-between">
          <Flex flexDirection="row">
            <Typography>{title}</Typography>
          </Flex>
          <Button
            color="info"
            variant="text"
            sx={{ fontWeight: 'regular' }}
            onClick={() => handleEdit(Number(id), path)}
          >
            {isPublished ? 'ดูข้อมูล' : 'แก้ไขข้อมูล'}
          </Button>
        </Flex>
        <Flex flexDirection="row" justifyContent="space-between">
          <Typography variant="caption">ความคืบหน้ารายงาน</Typography>
          <Typography>{progress}%</Typography>
        </Flex>

        <LinearProgress
          variant="determinate"
          value={progress}
          sx={(theme) => ({
            backgroundColor: theme.palette.secondary.lighter,
            '& .MuiLinearProgress-bar': {
              backgroundColor:
                progress === 100
                  ? theme.palette.success.main
                  : theme.palette.primary.main,
            },
          })}
        />
      </Box>
    </Flex>
  );
};
export default ProgressBarLayout;
